/**
 * Subscriptions API - Client-Side Service
 *
 * All subscription reads go through server-side Express API.
 * Client-side code MUST NOT access the database directly.
 */
import type { Subscription } from '../types/subscription';
import { apiFetch, pollEndpoint } from '@/lib/api-client';

/**
 * Get subscriptions visible to the current user.
 */
export async function getSubscriptions(): Promise<Subscription[]> {
  return apiFetch<Subscription[]>('/subscriptions');
}

/**
 * Poll subscriptions for the current user.
 * Returns cleanup function to stop polling.
 */
export function subscribeToSubscriptions(
  callback: (subscriptions: Subscription[]) => void,
  intervalMs: number = 60_000,
  onError?: (error: Error) => void
): () => void {
  return pollEndpoint<Subscription[]>('/subscriptions', callback, intervalMs, onError);
}
